import * as types from "./actionTypes";
import bovenLokaliteitPerDossierApi from "../api/bovenLokaliteitPerDossierApi";
import * as constants from "../constants/DomainConstants";
import * as ajax from "./ajaxCounterActions";
import * as exception from "./exceptionActions";
import * as beads from "./beadActions";


// ----------------------------------------------------------------------------
export function bovenLokaliteitPerDossierLoaded(bovenLokaliteitPerDossier, errors) {
	return {
		type: types.BOVEN_LOKALITEIT_PER_DOSSIER_LOADED,
		body: {
			item: bovenLokaliteitPerDossier,
			errors: errors
		}
	};
}

export function loadBovenLokaliteitPerDossier(infrastructuurId) {
	return (dispatch) => {
		dispatch(ajax.started());

		return bovenLokaliteitPerDossierApi.get(infrastructuurId)
			.then(response => {
				dispatch(ajax.ended());
				dispatch(bovenLokaliteitPerDossierLoaded(response.data.item, response.data.validationResults));
				dispatch(beads.beadsLoaded(response.data.item.beadModels));
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}

// ----------------------------------------------------------------------------
export function bovenLokaliteitPerDossierSaved(bovenLokaliteitPerDossier, errors) {
	return {
		type: types.BOVEN_LOKALITEIT_PER_DOSSIER_SAVED,
		body: {
			item: bovenLokaliteitPerDossier,
			errors: errors
		}
	};
}

export function saveBovenLokaliteitPerDossier(bovenLokaliteitPerDossier) {
	return (dispatch) => {
		dispatch(ajax.started());
		return bovenLokaliteitPerDossierApi.save(bovenLokaliteitPerDossier)
			.then((response) => {
				dispatch(ajax.ended());
				if (response.data.concurrencyException) {
					dispatch(bovenLokaliteitPerDossierSaved(response.data.item, response.data.validationResults));
					return constants.HAS_CONCURRENCY_EXCEPTION;
				}

				if (response.data.hasValidationErrors) {
					dispatch(bovenLokaliteitPerDossierSaved(response.data.item, response.data.validationResults));
					return constants.HAS_VALIDATION_ERRORS;
				}

				if (Object.keys(response.data.validationResults).length !== 0) {
					dispatch(bovenLokaliteitPerDossierSaved(response.data.item, response.data.validationResults));
					dispatch(beads.beadsLoaded(response.data.item.beadModels));
					return constants.HAS_VALIDATION_ERRORS_SAVED;
				}

				dispatch(bovenLokaliteitPerDossierSaved(response.data.item, response.data.validationResults));
				dispatch(beads.beadsLoaded(response.data.item.beadModels));
				return constants.SUCCESS;

			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}